import React, { useEffect, useRef, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import { BASE_URL } from '../../../config/axios';
import { formatDate } from '../../Date';
import { Monthprefix0, Projects, SubCompanyModern, YearModern } from '../../FilterDropdown';
import { CircularGrid, Eye, Filter, Office, DocumentIcon, Month, Year, Sort } from '../../AllSvg';
import { DownloadImprestBill } from '../../SiteManagement/BulkModals';
import { DateRangePicker, formatCurrencyIndian, formatDateTime, formatRoundoff2D, getMonthName, handleErrorToast, sortProjects, ViewDynamicApprovalDates, ViewDynamicApprovalRemarks, ViewDynamicApprovalStatus, ViewDynamicboqStatus, ViewRequestRemarks, ViewRequestRemarksImprest, ViewRequestStatus } from '../../CustomFunctions';
import { ApprovedVehicleBillingAdminC1, ApproveRequestVehicleBillingAccStage2, RejectVehicleBillingAdminC1 } from '../../VehicleBillingdetails/VehicleBillingActionButton';
import { DynamicRequestImprestApproval, DynamicRequestImprestEditApproval, DynamicRequestImprestRejection, DynamicRequestOfficeApproval, DynamicRequestOfficeRejection, DynamicRequestVehicleApproval, DynamicBillingFinal, DynamicRequestVehicleRejection, DynamicRequestOfficeEditApproval, DynamicRequestVehicleEditApproval, DynamicVehicleFinal, DynamicRequestImprestFinalize, DynamicRequestExpenseFinalize, DynamicRequestTenderApproval, DynamicRequestTenderRejection, DynamicRequestTenderEditApproval, DynamicRequestTenderFinalize, DynamicRequestLogTimeline } from './DynamicApprovalComponents';
import { ApprovedRequestOfficeBillingAccStage2 } from '../../OfficeRent/OfficeRentBillingTables';
import { useNavigate } from 'react-router-dom';
import { ChevronDown, ChevronUp, FileText, IndianRupee, Search, Sparkles, Users, Wallet, X } from 'lucide-react';

const DynamicImprestApprovalTable = ({ showdashboard, level, approval_stages }) => {
    const empId = sessionStorage.getItem('sitemanagement_emp_id');
    const role = sessionStorage.getItem('sitemanagement_role');
    const [buffer, setBuffering] = useState(true); //buffering logic
    const [buffer1, setBuffering1] = useState(true); //buffering logic
    const [ImprestList, setImprestList] = useState([]);
    const [previousStatus, setPreviousStatus] = useState("approved");
    const [selectedStatus, setSelectedStatus] = useState("pending");
    const [selectedProject, setProject] = useState("null");
    const [fromdate, setFromDate] = useState("null");
    const [todate, setToDate] = useState("null");
    const [selectedDivision, setDivision] = useState(
        `${sessionStorage.getItem("sitemanagement_project_sub_company") || null}`
    );
    const [SubCompany, setSubCompany] = useState([]);
    const [expandedRow, setExpandedRow] = useState(null);
    const [showFilters, setShowFilters] = useState(true);

    const toggleRow = (index) => setExpandedRow(expandedRow === index ? null : index);

    const defaultDivision = `${sessionStorage.getItem("sitemanagement_project_sub_company") || null}`;
    const hasActiveFilters =
        selectedStatus !== "pending" ||
        selectedProject !== "null" ||
        fromdate !== "null" ||
        todate !== "null" ||
        selectedDivision !== defaultDivision;

    const clearAllFilters = () => {
        setSelectedStatus("pending");
        setPreviousStatus("approved");
        setProject("null");
        setFromDate("null");
        setToDate("null");
        setDivision(defaultDivision);
    };

    const getSubCompany = async () => {
        setBuffering1(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompany(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering1(false); //buffering logic // End Buffering
        }
    };

    useEffect(() => {
        getSubCompany();
    }, [])

    //! ******************************API start***************************//
    const getDynamicImprestRequestData = async () => {
        try {
            setBuffering(true); //buffering logic // Start Buffering
            const res = await axios.get(
                `${BASE_URL}/siteproject/dynamicimprestapprovals/${previousStatus}/${level}/${selectedStatus}/${selectedDivision}/${selectedProject}/${fromdate}/${todate}/${role === "AuthorityEngineer" ? empId : null}/`
            );
            setImprestList(res.data)
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };

    useEffect(() => {
        if (level != 0) {
            getDynamicImprestRequestData();
        }
    }, [level, selectedStatus, selectedDivision, selectedProject, fromdate, todate])

    const getTotalAmount = (i) => {
        const useApproved = i.imprest_details?.change_log?.length > 1;
        return (
            Number(useApproved ? i.imprest_details?.approved_stationary_item : i.imprest_details?.stationary_item) +
            Number(useApproved ? i.imprest_details?.approved_electronic_item : i.imprest_details?.electronic_item) +
            Number(useApproved ? i.imprest_details?.approved_grocery : i.imprest_details?.grocery) +
            Number(i.imprest_details?.fixed_imprest_amount) +
            (i.imprest_details?.other_details?.length > 0
                ? i.imprest_details?.other_details?.reduce((total, other) => total + Number(useApproved ? other.approved_other : other.amount), 0)
                : 0)
        );
    };

    return (
        <div className="progress-modern-container">
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

            {showFilters && (
                <div className="filter-bar-attractive">
                    <div className="filter-group-attractive">


                        <div className={`filter-chip ${selectedProject !== "null" ? "active" : ""}`} style={{ paddingTop: '0px', paddingBottom: '0px' }}>
                            <div className="filter-chip-content">
                                <Projects usedFor="filter" value="id" toggleProject={selectedProject} setToggleProject={setProject} subcompany={selectedDivision} />
                            </div>
                        </div>

                        <div className={`filter-chip ${selectedStatus !== "pending" ? "active" : ""}`}>
                            <Filter size={15} />
                            <div className="filter-chip-content">
                                <select
                                    className="modern-select"
                                    value={selectedStatus}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setSelectedStatus(value);
                                        setPreviousStatus(value === "rejected" ? "pending" : "approved");
                                    }}
                                >
                                    <option value="null">All</option>
                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                            </div>
                        </div>

                        <div className={`filter-chip ${fromdate !== "null" || todate !== "null" ? "active" : ""}`} style={{ padding: "0px", width: "20vw" }} title="Date Range">
                            <div className="filter-chip-content">
                                <DateRangePicker
                                    startDate={fromdate}
                                    endDate={todate}
                                    placeHolder1="From Date"
                                    placeHolder2="To Date"
                                    onChange={(start, end) => {
                                        setFromDate(start);
                                        setToDate(end);
                                    }}
                                />
                            </div>
                        </div>

                        {hasActiveFilters && (
                            <button className="clear-filters-btn" onClick={clearAllFilters}>
                                <X size={13} />
                                Clear
                            </button>
                        )}
                    </div>
                </div>
            )}

            <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
                <div className="stats-minimal-row">
                    <div className="stat-minimal-item">
                        <Wallet size={14} />
                        <span>Stage {level} — Showing</span>
                        <strong>{ImprestList.length} requests</strong>
                    </div>
                </div>

                <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
                    <button className="toggle-filters-btn" onClick={() => setShowFilters(!showFilters)}>
                        <Filter size={14} />
                        <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                        {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                    </button>

                    <DownloadImprestBill projectList={ImprestList} />
                </div>
            </div>

            <div className="table-wrapper-minimal table-box scroll-container-table">
                {buffer ? (
                    <div className="loader-minimal"><div className="spinner-minimal"></div></div>
                ) : (
                    <table className="progress-table-minimal">
                        <thead className="table-heading stciky-heading-top">
                            <tr>
                                <th className="col-sno" style={{ width: '5%' }}>#</th>
                                <th className="col-period" style={{ width: '24%' }}>Imprest / Project</th>
                                <th className="col-submitted text-center" style={{ width: '15%' }}>Total Amount</th>
                                <th className="col-approved text-center" style={{ width: '8%' }}>Days</th>
                                <th className="col-status text-center" style={{ width: '14%' }}>Status</th>
                                <th className="col-action text-center" style={{ width: '18%' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {ImprestList.map((i, index) => {
                                const isExpanded = expandedRow === index;
                                const total = getTotalAmount(i);
                                const nextApproval = i.imprest_details.dynamic_approval.find(
                                    (approval) => approval.level === i.level + 1
                                );
                                const shouldShowButtons =
                                    !nextApproval ||
                                    nextApproval.approval_status !== 'approved';

                                return (
                                    <React.Fragment key={index}>
                                        <tr className="progress-row" title={`Team Leader Status : ${i.imprest_details?.authority_approval_status}`}>
                                            <td className="col-sno text-start">{index + 1}.</td>
                                            <td className="col-period">
                                                <button className="period-trigger" style={{ width: "100%" }} onClick={() => toggleRow(index)}>
                                                    <Wallet size={12} />
                                                    <span>{i.imprest_details?.imprest_name}</span>
                                                    {isExpanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                                                </button>
                                                <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '4px', paddingLeft: '4px' }}>
                                                    {i.imprest_details?.project_code}/{i.imprest_details?.project_short_name} • {formatDate(i.imprest_details?.date)}
                                                </div>
                                            </td>
                                            <td className="col-submitted text-center" title={`${i.imprest_details?.change_log?.length > 1 ? 'Approved Amount' : 'Proposed Amount'}`}>
                                                <span className="badge-value">₹{formatCurrencyIndian(total)}</span>
                                            </td>
                                            <td className="col-approved text-center">
                                                <b>{i.imprest_details?.no_of_days}</b>
                                            </td>
                                            <td className="col-status text-center">
                                                <ViewDynamicApprovalStatus dynamic_approval={i.imprest_details?.dynamic_approval} />
                                            </td>
                                            <td className="col-action text-center">
                                                <div className="action-group-minimal" style={{ justifyContent: 'center' }}>
                                                    {shouldShowButtons ? (
                                                        <>
                                                            {(i.approval_status === 'pending' || i.approval_status === 'rejected') && (
                                                                <>
                                                                    {i.permissions === 'Finalize' ? (
                                                                        <DynamicRequestImprestFinalize i={i} getDynamicRequestData={getDynamicImprestRequestData} />
                                                                    ) : (
                                                                        <DynamicRequestImprestApproval i={i} getDynamicRequestData={getDynamicImprestRequestData} />
                                                                    )}
                                                                    {i.permissions === 'Approve-Reject-Edit' && (
                                                                        <DynamicRequestImprestEditApproval i={i} getDynamicRequestData={getDynamicImprestRequestData} />
                                                                    )}
                                                                </>
                                                            )}
                                                            {(i.approval_status === 'pending' || i.approval_status === 'approved') && (
                                                                <DynamicRequestImprestRejection i={i} getDynamicRequestData={getDynamicImprestRequestData} />
                                                            )}
                                                        </>
                                                    ) : (
                                                        <span style={{ fontSize: '11px', color: '#94a3b8' }}>Next Stage Action Performed</span>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>

                                        {isExpanded && (
                                            <tr className="expanded-row">
                                                <td colSpan={6}>
                                                    <div className="expanded-content-attractive">
                                                        <div className="expanded-content-header">
                                                            <div className="expanded-content-title">
                                                                <Sparkles size={13} />
                                                                <span>Full Imprest Details</span>
                                                            </div>
                                                        </div>

                                                        <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap', marginBottom: '14px' }}>
                                                            <div className="stage-card submitted" style={{ flex: 1, minWidth: '240px' }}>
                                                                <div className="stage-header">
                                                                    <IndianRupee size={14} />
                                                                    <span>{i.imprest_details?.change_log?.length > 1 ? 'Approved Breakdown' : 'Proposed Breakdown'}</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    {[
                                                                        { name: 'Stationary', value: i.imprest_details?.change_log?.length > 1 ? i.imprest_details?.approved_stationary_item : i.imprest_details?.stationary_item },
                                                                        { name: 'Electronics', value: i.imprest_details?.change_log?.length > 1 ? i.imprest_details?.approved_electronic_item : i.imprest_details?.electronic_item },
                                                                        { name: 'Grocery', value: i.imprest_details?.change_log?.length > 1 ? i.imprest_details?.approved_grocery : i.imprest_details?.grocery },
                                                                    ].map(({ name, value }) => Number(value) !== 0 && (
                                                                        <div className="stage-row" key={name}>
                                                                            <span className="stage-label">{name}</span>
                                                                            <span className="amount">₹{formatCurrencyIndian(value)}</span>
                                                                        </div>
                                                                    ))}
                                                                    {i.imprest_details?.fixed_imprest_amount ? (
                                                                        <div className="stage-row">
                                                                            <span className="stage-label">Site Imprest Amount</span>
                                                                            <span className="amount">₹{formatCurrencyIndian(i.imprest_details?.fixed_imprest_amount)}</span>
                                                                        </div>
                                                                    ) : null}
                                                                    {i.imprest_details?.other_details?.length > 0 && i.imprest_details.other_details.map((other, idx) => (
                                                                        <div className="stage-row" key={other.other_name || `other-${idx}`}>
                                                                            <span className="stage-label">{other.other_name || `Other-${idx + 1}`}</span>
                                                                            <span className="amount">₹{formatCurrencyIndian(Number(i.imprest_details?.change_log?.length > 1 ? other.approved_other : other.amount))}</span>
                                                                        </div>
                                                                    ))}
                                                                    <div className="stage-row" style={{ fontWeight: 700 }}>
                                                                        <span className="stage-label">Total</span>
                                                                        <span className="amount">₹{formatCurrencyIndian(total)}</span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="stage-card recommended" style={{ flex: 1, minWidth: '240px' }}>
                                                                <div className="stage-header">
                                                                    <Users size={14} />
                                                                    <span>Approval Timeline</span>
                                                                </div>
                                                                <div style={{ padding: '0 12px 10px' }}>
                                                                    <DynamicRequestLogTimeline i={i.imprest_details} detailedCheckKeys={['other_details', 'dynamic_approval']} />
                                                                </div>
                                                            </div>

                                                            <div className="stage-card" style={{ flex: 1, minWidth: '240px', background: 'white' }}>
                                                                <div className="stage-header">
                                                                    <FileText size={14} />
                                                                    <span>Remarks</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    <ViewDynamicApprovalRemarks dynamic_approval={i.imprest_details?.dynamic_approval} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                            {ImprestList.length === 0 && (
                                <tr>
                                    <td colSpan={6}>
                                        <div className="empty-state-attractive">
                                            <div className="empty-state-icon-wrap"><Wallet size={32} /></div>
                                            <h4 className="empty-state-title">No Imprest Requests Found</h4>
                                            <p className="empty-state-subtitle">No imprest requests are pending at this stage.</p>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};
const DynamicsExpenseApproveTable = ({ showdashboard, level, approval_stages }) => {
    const empId = sessionStorage.getItem('sitemanagement_emp_code');
    const role = sessionStorage.getItem('sitemanagement_role');
    const [buffer, setBuffering] = useState(true); //buffering logic
    const [buffer1, setBuffering1] = useState(true); //buffering logic

    const [ExpenseList, setExpenseList] = useState([]);

    const [previousStatus, setPreviousStatus] = useState("approved");
    const [selectedStatus, setSelectedStatus] = useState("pending");
    const [selectedProject, setProject] = useState("null");

    const [fromdate, setFromDate] = useState("null");
    const [todate, setToDate] = useState("null");

    const [selectedDivision, setDivision] = useState(
        `${sessionStorage.getItem("sitemanagement_project_sub_company") || null}`
    );

    const [SubCompany, setSubCompany] = useState([]);
    const [expandedRow, setExpandedRow] = useState(null);
    const [showFilters, setShowFilters] = useState(true);

    const toggleRow = (index) => setExpandedRow(expandedRow === index ? null : index);

    const defaultDivision = `${sessionStorage.getItem("sitemanagement_project_sub_company") || null}`;
    const hasActiveFilters =
        selectedStatus !== "pending" ||
        selectedProject !== "null" ||
        fromdate !== "null" ||
        todate !== "null" ||
        selectedDivision !== defaultDivision;

    const clearAllFilters = () => {
        setSelectedStatus("pending");
        setPreviousStatus("approved");
        setProject("null");
        setFromDate("null");
        setToDate("null");
        setDivision(defaultDivision);
    };

    const getSubCompany = async () => {
        setBuffering1(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/ `);
            setSubCompany(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering1(false); //buffering logic // End Buffering
        }
    };

    useEffect(() => {
        getSubCompany();
    }, [])

    //! ******************************API start***************************//
    const getDynamicExpenseRequestData = async () => {
        try {
            setBuffering(true); //buffering logic // Start Buffering
            const res = await axios.get(
                `${BASE_URL}/siteproject/expensedynamicapprovalspreviousfilter/${previousStatus}/${level}/${selectedStatus}/${selectedDivision}/${selectedProject}/${fromdate}/${todate}/${role === "AuthorityEngineer" ? empId : null}/`
            );
            setExpenseList(res.data)
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };

    useEffect(() => {
        if (level != 0) {
            getDynamicExpenseRequestData();
        }
    }, [level, selectedStatus, selectedDivision, selectedProject, fromdate, todate])

    const navigate = useNavigate();
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split("/");
    const baseUrl = "/" + urlParts[3] + `/requestExpenseSlip/`;
    const opener = sessionStorage.getItem('sitemanagement_role')
    const openExenseSlip = (i, reqData) => {
        navigate(baseUrl + i.id + '/', { state: { i, reqData, opener } });
    };

    const getApprovedTotal = (i) => {
        return (
            Number(i.expense_details?.imprest_data?.approved_stationary_item) +
            Number(i.expense_details?.imprest_data?.approved_electronic_item) +
            Number(i.expense_details?.imprest_data?.approved_grocery) +
            (i.expense_details?.imprest_data?.other_details?.length > 0
                ? i.expense_details?.imprest_data?.other_details?.reduce(
                    (total, other) => total + Number(other.approved_other || 0),
                    0
                )
                : 0)
        );
    };

    return (
        <div className="progress-modern-container">
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

            {showFilters && (
                <div className="filter-bar-attractive">
                    <div className="filter-group-attractive">

                        <div className={`filter-chip ${selectedProject !== "null" ? "active" : ""}`} style={{ paddingTop: '0px', paddingBottom: '0px' }}>
                            <div className="filter-chip-content">
                                <Projects usedFor="filter" value="id" toggleProject={selectedProject} setToggleProject={setProject} subcompany={selectedDivision} />
                            </div>
                        </div>



                        <div className={`filter-chip ${selectedStatus !== "pending" ? "active" : ""}`}>
                            <Filter size={15} />
                            <div className="filter-chip-content">
                                <select
                                    className="modern-select"
                                    value={selectedStatus}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setSelectedStatus(value);
                                        setPreviousStatus(value === "rejected" ? "pending" : "approved");
                                    }}
                                >
                                    <option value="null">All</option>
                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                            </div>
                        </div>

                        <div className={`filter-chip ${fromdate !== "null" || todate !== "null" ? "active" : ""}`} style={{ padding: "0px", width: "20vw" }} title="Date Range">
                            <div className="filter-chip-content">
                                <DateRangePicker
                                    startDate={fromdate}
                                    endDate={todate}
                                    placeHolder1="From Date"
                                    placeHolder2="To Date"
                                    onChange={(start, end) => {
                                        setFromDate(start);
                                        setToDate(end);
                                    }}
                                />
                            </div>
                        </div>

                        {hasActiveFilters && (
                            <button className="clear-filters-btn" onClick={clearAllFilters}>
                                <X size={13} />
                                Clear
                            </button>
                        )}
                    </div>
                </div>
            )}

            <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
                <div className="stats-minimal-row">
                    <div className="stat-minimal-item">
                        <IndianRupee size={14} />
                        <span>Stage {level} — Showing</span>
                        <strong>{ExpenseList.length} expenses</strong>
                    </div>
                </div>

                <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
                    <button className="toggle-filters-btn" onClick={() => setShowFilters(!showFilters)}>
                        <Filter size={14} />
                        <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                        {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                    </button>
                </div>
            </div>

            <div className="table-wrapper-minimal table-box scroll-container-table">
                {buffer ? (
                    <div className="loader-minimal"><div className="spinner-minimal"></div></div>
                ) : (
                    <table className="progress-table-minimal">
                        <thead className="table-heading stciky-heading-top">
                            <tr>
                                <th className="col-sno" style={{ width: '5%' }}>#</th>
                                <th className="col-period" style={{ width: '24%' }}>Expense / Project</th>
                                <th className="col-submitted text-center" style={{ width: '13%' }}>Imprest Amount</th>
                                <th className="col-submitted text-center" style={{ width: '13%' }}>Expense Amount</th>
                                <th className="col-status text-center" style={{ width: '14%' }}>Status</th>
                                <th className="col-action text-center" style={{ width: '18%' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {ExpenseList.map((i, index) => {
                                const isExpanded = expandedRow === index;
                                const approvedTotal = getApprovedTotal(i);

                                return (
                                    <React.Fragment key={index}>
                                        <tr className="progress-row">
                                            <td className="col-sno text-start">{index + 1}.</td>
                                            <td className="col-period">
                                                <button className="period-trigger" style={{ width: "100%" }} onClick={() => toggleRow(index)}>
                                                    <IndianRupee size={12} />
                                                    <span>{i.expense_details?.name}</span>
                                                    {isExpanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                                                </button>
                                                <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '4px', paddingLeft: '4px' }}>
                                                    {i.expense_details?.imprest_data?.project_short_name || "N/A"} • {formatDate(i.expense_details?.date)}
                                                </div>
                                            </td>
                                            <td className="col-submitted text-center">
                                                {i.expense_details?.imprest_data?.amount_change_reason ? (
                                                    <span className="badge-value" title={`Reason For Change : \n${i.expense_details?.imprest_data?.amount_change_reason}`}>
                                                        ₹{formatCurrencyIndian(approvedTotal)}
                                                    </span>
                                                ) : (
                                                    <span style={{ color: '#94a3b8' }}>-</span>
                                                )}
                                            </td>
                                            <td className="col-submitted text-center">
                                                {i.expense_details?.submit_for_approval === false ? (
                                                    <span request-status={"pending"} className="request-status">
                                                        Not Submitted
                                                    </span>
                                                ) : (
                                                    <span className="badge-value" title={`Utilized: ${i.expense_details?.utilized_amount ? formatRoundoff2D(i.expense_details?.utilized_amount) : '-'} | Remaining: ${i.expense_details?.remaining_amount ? formatRoundoff2D(i.expense_details?.remaining_amount) : '-'}`}>
                                                        {i.expense_details?.utilized_amount ? formatRoundoff2D(i.expense_details?.utilized_amount) : '-'}
                                                    </span>
                                                )}
                                            </td>
                                            <td className="col-status text-center">
                                                <ViewDynamicApprovalStatus dynamic_approval={i.expense_details?.dynamic_approval} />
                                            </td>
                                            <td className="col-action text-center">
                                                <div className="action-group-minimal" style={{ justifyContent: 'center' }}>
                                                    {i.permissions === 'Finalize' && (
                                                        <DynamicRequestExpenseFinalize i={i} j={i.expense_details} getDynamicRequestData={getDynamicExpenseRequestData} />
                                                    )}
                                                    <button
                                                        className="allproject-dashboard"
                                                        title="View using Navigate"
                                                        onClick={(e) => openExenseSlip(i.expense_details, i)}
                                                    >
                                                        <Eye size={14} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>

                                        {isExpanded && (
                                            <tr className="expanded-row">
                                                <td colSpan={6}>
                                                    <div className="expanded-content-attractive">
                                                        <div className="expanded-content-header">
                                                            <div className="expanded-content-title">
                                                                <Sparkles size={13} />
                                                                <span>Full Expense Details</span>
                                                            </div>
                                                        </div>

                                                        <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap', marginBottom: '14px' }}>
                                                            <div className="stage-card submitted" style={{ flex: 1, minWidth: '240px' }}>
                                                                <div className="stage-header">
                                                                    <IndianRupee size={14} />
                                                                    <span>Approved Imprest Breakdown</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    {[
                                                                        { name: 'Stationary', value: i.expense_details?.imprest_data?.approved_stationary_item, proposed: i.expense_details?.imprest_data?.stationary_item },
                                                                        { name: 'Electronics', value: i.expense_details?.imprest_data?.approved_electronic_item, proposed: i.expense_details?.imprest_data?.electronic_item },
                                                                        { name: 'Grocery', value: i.expense_details?.imprest_data?.approved_grocery, proposed: i.expense_details?.imprest_data?.grocery },
                                                                    ].map(({ name, value, proposed }) => Number(proposed) !== 0 && (
                                                                        <div className="stage-row" key={name}>
                                                                            <span className="stage-label">{name}</span>
                                                                            <span className="amount">₹{formatCurrencyIndian(value)}</span>
                                                                        </div>
                                                                    ))}
                                                                    {i.expense_details?.imprest_data?.other_details?.length > 0 && i.expense_details.imprest_data.other_details.map((other, idx) => (
                                                                        <div className="stage-row" key={other.other_name || `other-${idx}`}>
                                                                            <span className="stage-label">{other.other_name || `Other-${idx + 1}`}</span>
                                                                            <span className="amount">₹{formatCurrencyIndian(other.approved_other || 0)}</span>
                                                                        </div>
                                                                    ))}
                                                                    <div className="stage-row" style={{ fontWeight: 700 }}>
                                                                        <span className="stage-label">Total</span>
                                                                        <span className="amount">₹{formatCurrencyIndian(approvedTotal)}</span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="stage-card recommended" style={{ flex: 1, minWidth: '240px' }}>
                                                                <div className="stage-header">
                                                                    <Users size={14} />
                                                                    <span>Approval Timeline</span>
                                                                </div>
                                                                <div style={{ padding: '0 12px 10px' }}>
                                                                    <DynamicRequestLogTimeline i={i.expense_details} detailedCheckKeys={['other_details', 'dynamic_approval']} />
                                                                </div>
                                                            </div>

                                                            <div className="stage-card" style={{ flex: 1, minWidth: '240px', background: 'white' }}>
                                                                <div className="stage-header">
                                                                    <FileText size={14} />
                                                                    <span>Remarks</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    <ViewDynamicApprovalRemarks dynamic_approval={i.expense_details?.dynamic_approval} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                            {ExpenseList.length === 0 && (
                                <tr>
                                    <td colSpan={6}>
                                        <div className="empty-state-attractive">
                                            <div className="empty-state-icon-wrap"><IndianRupee size={32} /></div>
                                            <h4 className="empty-state-title">No Expense Requests Found</h4>
                                            <p className="empty-state-subtitle">No expense requests are pending at this stage.</p>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};
const DynamicOfficeBillingTable = ({ showdashboard, level, approval_stages }) => {
    const today = new Date();
    today.setDate(today.getDate() - 1);
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 20;
    const endYear = currentYear + 20;
    const years = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);

    const [filterMonth, setFilterMonth] = useState(`${month ? `0${month}` : "null"}`);
    const [filterYear, setFilterYear] = useState(`${year ? year : 'null'}`);
    const tableRef = useRef(null);

    const empId = sessionStorage.getItem('sitemanagement_emp_id');
    const role = sessionStorage.getItem('sitemanagement_role');

    const [buffer, setBuffering] = useState(true); //buffering logic

    const [OfficeBillingList, setOfficeBillingList] = useState([]);

    const [previousStatus, setPreviousStatus] = useState("approved");
    const [selectedStatus, setSelectedStatus] = useState("pending");
    const [selectedProject, setProject] = useState("null");

    const [fromdate, setFromDate] = useState("null");
    const [todate, setToDate] = useState("null");
    const [selectedDivision, setDivision] = useState(
        `${sessionStorage.getItem("sitemanagement_project_sub_company") || null}`
    );

    const [SubCompany, setSubCompany] = useState([]);
    const [expandedRow, setExpandedRow] = useState(null);
    const [showFilters, setShowFilters] = useState(true);

    const toggleRow = (index) => setExpandedRow(expandedRow === index ? null : index);

    const defaultMonth = `${month ? `0${month}` : "null"}`;
    const defaultYear = `${year ? year : 'null'}`;
    const defaultDivision = `${sessionStorage.getItem("sitemanagement_project_sub_company") || null}`;

    const hasActiveFilters =
        selectedStatus !== "pending" ||
        selectedProject !== "null" ||
        filterMonth !== defaultMonth ||
        filterYear !== defaultYear ||
        selectedDivision !== defaultDivision;

    const clearAllFilters = () => {
        setSelectedStatus("pending");
        setPreviousStatus("approved");
        setProject("null");
        setFilterMonth(defaultMonth);
        setFilterYear(defaultYear);
        setDivision(defaultDivision);
    };

    const getSubCompany = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/ `);
            setSubCompany(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    useEffect(() => {
        getSubCompany();
    }, [])

    //! ******************************API start***************************//
    const getOfficeRentBillingData = async () => {
        try {
            setBuffering(true); //buffering logic // Start Buffering
            const res = await axios.get(
                `${BASE_URL}/siteproject/officerentdynamicapprovalspreviousmonthyearfilter/${previousStatus}/${level}/${selectedStatus}/${selectedDivision}/${selectedProject}/${filterMonth}/${filterYear}/${role === "AuthorityEngineer" ? empId : null}/`
            );
            setOfficeBillingList(res.data)
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };

    useEffect(() => {
        if (level != 0) {
            getOfficeRentBillingData();
        }
    }, [level, selectedStatus, selectedProject, filterMonth, filterYear])

    //! *********** Employee Details Api End ***********

    return (
        <div className="progress-modern-container">
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

            {showFilters && (
                <div className="filter-bar-attractive">
                    <div className="filter-group-attractive">

                        <div className={`filter-chip ${selectedProject !== "null" ? "active" : ""}`} style={{ paddingTop: '0px', paddingBottom: '0px' }}>
                            <div className="filter-chip-content">
                                <Projects usedFor="filter" value="id" toggleProject={selectedProject} setToggleProject={setProject} subcompany={selectedDivision} />
                            </div>
                        </div>

                        <div className={`filter-chip ${filterMonth !== defaultMonth ? "active" : ""}`} style={{ padding: "0px" }} title="Month Filter">
                            <Monthprefix0 filterMonth={filterMonth} setFilterMonth={setFilterMonth} cssType="modern" />
                        </div>

                        <div className={`filter-chip ${filterYear !== defaultYear ? "active" : ""}`} style={{ padding: "0px" }} title="Year Filter">
                            <YearModern filterYear={filterYear} setFilterYear={setFilterYear} cssType="modern" />

                        </div>

                        <div className={`filter-chip ${selectedStatus !== "pending" ? "active" : ""}`}>
                            <Filter size={15} />
                            <div className="filter-chip-content">
                                <select
                                    className="modern-select"
                                    value={selectedStatus}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setSelectedStatus(value);
                                        setPreviousStatus(value === "rejected" ? "pending" : "approved");
                                    }}
                                >
                                    <option value="null">All</option>
                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                            </div>
                        </div>



                        {hasActiveFilters && (
                            <button className="clear-filters-btn" onClick={clearAllFilters}>
                                <X size={13} />
                                Clear
                            </button>
                        )}
                    </div>
                </div>
            )}

            <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
                <div className="stats-minimal-row">
                    <div className="stat-minimal-item">
                        <IndianRupee size={14} />
                        <span>Stage {level} — Showing</span>
                        <strong>{OfficeBillingList.length} bills</strong>
                    </div>
                </div>

                <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
                    <button className="toggle-filters-btn" onClick={() => setShowFilters(!showFilters)}>
                        <Filter size={14} />
                        <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                        {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                    </button>
                </div>
            </div>

            <div className="table-wrapper-minimal table-box scroll-container-table" ref={tableRef}>
                {buffer ? (
                    <div className="loader-minimal"><div className="spinner-minimal"></div></div>
                ) : (
                    <table className="progress-table-minimal">
                        <thead className="table-heading stciky-heading-top">
                            <tr>
                                <th className="col-sno" style={{ width: '5%' }}>#</th>
                                <th className="col-period" style={{ width: '26%' }}>Project / Period</th>
                                <th className="col-submitted text-center" style={{ width: '16%' }}>Total Amount</th>
                                <th className="col-status text-center" style={{ width: '15%' }}>Status</th>
                                <th className="col-action text-center" style={{ width: '20%' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {OfficeBillingList.map((i, index) => {
                                const isExpanded = expandedRow === index;
                                const details = i?.officerent_billing_details;

                                const totalAmt = details?.total_amt === 0
                                    ? (details?.total_amt || 0)
                                    : (details?.rent_amt || 0) - ((details?.rent_amt || 0) * ((details?.tds_percentage || 0) / 100));

                                const nextApproval = details?.dynamic_approval?.find(
                                    (approval) => approval.level === i.level + 1
                                );
                                const shouldShowButtons =
                                    !nextApproval ||
                                    nextApproval.approval_status !== 'approved';

                                return (
                                    <React.Fragment key={index}>
                                        <tr className="progress-row">
                                            <td className="col-sno text-start">{index + 1}.</td>
                                            <td className="col-period">
                                                <button className="period-trigger" style={{ width: "100%" }} onClick={() => toggleRow(index)}>
                                                    <IndianRupee size={12} />
                                                    <span>{details?.project_short_name}</span>
                                                    {isExpanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                                                </button>
                                                <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '4px', paddingLeft: '4px' }}>
                                                    {getMonthName(details?.month)}/{details?.year} • {formatDate(details?.date)}
                                                </div>
                                            </td>
                                            <td className="col-submitted text-center">
                                                <span className="badge-value" title={`Rent: ${formatCurrencyIndian(details?.rent_amt || 0)} | TDS: ${formatCurrencyIndian(details?.tds_amt || 0)} (${details?.tds_percentage}%)`}>
                                                    ₹{formatCurrencyIndian(totalAmt)}
                                                </span>
                                            </td>
                                            <td className="col-status text-center">
                                                <ViewDynamicApprovalStatus dynamic_approval={details?.dynamic_approval} />
                                            </td>
                                            <td className="col-action text-center">
                                                <div className="action-group-minimal" style={{ justifyContent: 'center' }}>
                                                    {shouldShowButtons ? (
                                                        (i.approval_status === 'pending' || i.approval_status === 'rejected') && (
                                                            <>
                                                                {i.permissions === 'Finalize' ? (
                                                                    <DynamicBillingFinal
                                                                        i={i}
                                                                        getofficebillingdata={getOfficeRentBillingData}
                                                                        documentlist={details?.documents}
                                                                    />
                                                                ) : (
                                                                    <DynamicRequestOfficeApproval i={i} getDynamicRequestData={getOfficeRentBillingData} />
                                                                )}
                                                                {i.permissions === 'Approve-Reject-Edit' && (
                                                                    <DynamicRequestOfficeEditApproval i={i} getDynamicRequestData={getOfficeRentBillingData} documentlist={details?.documents} />
                                                                )}
                                                                {(i.approval_status === 'pending' || i.approval_status === 'approved') && (
                                                                    <DynamicRequestOfficeRejection i={i} getDynamicRequestData={getOfficeRentBillingData} />
                                                                )}
                                                            </>
                                                        )
                                                    ) : (
                                                        <span style={{ fontSize: '11px', color: '#94a3b8' }}>Next Stage Action Performed</span>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>

                                        {isExpanded && (
                                            <tr className="expanded-row">
                                                <td colSpan={5}>
                                                    <div className="expanded-content-attractive">
                                                        <div className="expanded-content-header">
                                                            <div className="expanded-content-title">
                                                                <Sparkles size={13} />
                                                                <span>Full Billing Details</span>
                                                            </div>
                                                        </div>

                                                        <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap', marginBottom: '14px' }}>
                                                            <div className="stage-card submitted" style={{ flex: 1, minWidth: '240px' }}>
                                                                <div className="stage-header">
                                                                    <IndianRupee size={14} />
                                                                    <span>Amount Breakdown</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Rent Amount</span>
                                                                        <span className="amount">₹{formatCurrencyIndian(details?.rent_amt || 0)}</span>
                                                                    </div>
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">TDS ({details?.tds_percentage}%)</span>
                                                                        <span className="amount">₹{formatCurrencyIndian(details?.tds_amt || 0)}</span>
                                                                    </div>
                                                                    <div className="stage-row" style={{ fontWeight: 700 }}>
                                                                        <span className="stage-label">Total Amount</span>
                                                                        <span className="amount">₹{formatCurrencyIndian(totalAmt)}</span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="stage-card" style={{ flex: 1, minWidth: '240px', background: 'white' }}>
                                                                <div className="stage-header">
                                                                    <Users size={14} />
                                                                    <span>Owner Details</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Owner Name</span>
                                                                        <span className="amount">{details?.owner_name || '-'}</span>
                                                                    </div>
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Account Holder</span>
                                                                        <span className="amount">{details?.account_holder_name || '-'}</span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="stage-card recommended" style={{ flex: 1, minWidth: '240px' }}>
                                                                <div className="stage-header">
                                                                    <Users size={14} />
                                                                    <span>Approval Timeline</span>
                                                                </div>
                                                                <div style={{ padding: '0 12px 10px' }}>
                                                                    <DynamicRequestLogTimeline i={details} detailedCheckKeys={['dynamic_approval']} />
                                                                </div>
                                                            </div>

                                                            <div className="stage-card" style={{ flex: 1, minWidth: '240px', background: 'white' }}>
                                                                <div className="stage-header">
                                                                    <FileText size={14} />
                                                                    <span>Remarks</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    <ViewDynamicApprovalRemarks dynamic_approval={details?.dynamic_approval} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                            {OfficeBillingList.length === 0 && (
                                <tr>
                                    <td colSpan={5}>
                                        <div className="empty-state-attractive">
                                            <div className="empty-state-icon-wrap"><IndianRupee size={32} /></div>
                                            <h4 className="empty-state-title">No Office Billing Requests Found</h4>
                                            <p className="empty-state-subtitle">No office rent bills are pending at this stage.</p>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

const DynamicVehicleApprovalTable = ({ showdashboard, level, approval_stages }) => {

    const empId = sessionStorage.getItem('sitemanagement_emp_id');
    const role = sessionStorage.getItem('sitemanagement_role');
    const today = new Date();
    today.setDate(today.getDate() - 1);
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 20;
    const endYear = currentYear + 20;
    const years = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);
    const [filterMonth, setFilterMonth] = useState(`${month ? `0${month}` : "null"}`);
    const [filterYear, setFilterYear] = useState(`${year ? year : 'null'}`);

    const [buffer, setBuffering] = useState(true); //buffering logic

    const [VehicleBillingList, setVehicleBillingList] = useState([]);

    const [previousStatus, setPreviousStatus] = useState("approved");
    const [selectedStatus, setSelectedStatus] = useState("pending");
    const [selectedProject, setProject] = useState("null");

    const [fromdate, setFromDate] = useState("null");
    const [todate, setToDate] = useState("null");

    const [selectedDivision, setDivision] = useState(
        `${sessionStorage.getItem("sitemanagement_project_sub_company") || null}`
    );

    const [SubCompany, setSubCompany] = useState([]);
    const [expandedRow, setExpandedRow] = useState(null);
    const [showFilters, setShowFilters] = useState(true);

    const toggleRow = (index) => setExpandedRow(expandedRow === index ? null : index);

    const defaultMonth = `${month ? `0${month}` : "null"}`;
    const defaultYear = `${year ? year : 'null'}`;
    const defaultDivision = `${sessionStorage.getItem("sitemanagement_project_sub_company") || null}`;

    const hasActiveFilters =
        selectedStatus !== "pending" ||
        selectedProject !== "null" ||
        filterMonth !== defaultMonth ||
        filterYear !== defaultYear ||
        selectedDivision !== defaultDivision;

    const clearAllFilters = () => {
        setSelectedStatus("pending");
        setPreviousStatus("approved");
        setProject("null");
        setFilterMonth(defaultMonth);
        setFilterYear(defaultYear);
        setDivision(defaultDivision);
    };

    const getSubCompany = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompany(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    useEffect(() => {
        getSubCompany();
    }, [])

    //! ******************************API start***************************//
    const getVehicleBillingData = async () => {
        try {
            setBuffering(true); //buffering logic // Start Buffering
            const res = await axios.get(
                `${BASE_URL}/siteproject/vehicledynamicapprovalsprojectpreviousbyprojectmonthyear/${previousStatus}/${level}/${selectedStatus}/null/${selectedProject}/${filterMonth}/${filterYear}/${role === "AuthorityEngineer" ? empId : null}/`
            );
            setVehicleBillingList(res.data)
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };

    useEffect(() => {
        if (level != 0) {
            getVehicleBillingData();
        }
    }, [level, selectedStatus, selectedProject, filterMonth, filterYear])

    const [vehicleList, setVehicleList] = useState([]);
    const [vehicle, setVehicle] = useState("null");

    const getVehicle = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const veh = await axios.get(`${BASE_URL}/siteproject/vehiclefilterapi/${selectedProject}/`);
            setVehicleList(veh.data);
        } catch (err) {
            handleErrorToast(err)
        } finally {
            setBuffering(false);// End Buffering
        }
    }

    useEffect(() => {
        getVehicle();
    }, [selectedProject])
    //! *********** Employee Details Api End ***********

    return (
        <div className="progress-modern-container">
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

            {showFilters && (
                <div className="filter-bar-attractive">
                    <div className="filter-group-attractive">

                        <div className={`filter-chip ${selectedProject !== "null" ? "active" : ""}`} style={{ paddingTop: '0px', paddingBottom: '0px' }}>
                            <div className="filter-chip-content">
                                <Projects usedFor="filter" value="id" toggleProject={selectedProject} setToggleProject={setProject} subcompany={selectedDivision} />
                            </div>
                        </div>

                        <div className={`filter-chip ${filterMonth !== defaultMonth ? "active" : ""}`} style={{ padding: "0px" }} title="Month Filter">
                            <Monthprefix0 filterMonth={filterMonth} setFilterMonth={setFilterMonth} cssType="modern" />
                        </div>

                        <div className={`filter-chip ${filterYear !== defaultYear ? "active" : ""}`} style={{ padding: "0px" }} title="Year Filter">
                            <YearModern filterYear={filterYear} setFilterYear={setFilterYear} cssType="modern" />

                        </div>
                        <div className={`filter-chip ${selectedStatus !== "pending" ? "active" : ""}`}>
                            <Filter size={15} />
                            <div className="filter-chip-content">
                                <select
                                    className="modern-select"
                                    value={selectedStatus}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setSelectedStatus(value);
                                        setPreviousStatus(value === "rejected" ? "pending" : "approved");
                                    }}
                                >
                                    <option value="null">All</option>
                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                            </div>
                        </div>

                        {/* Vehicle filter kept disabled, as in original */}
                        {/* {selectedProject !== "null" &&
                            <div className={`filter-chip ${vehicle !== "null" ? "active" : ""}`} title="Vehicle Filter">
                                <CircularGrid />
                                <div className="filter-chip-content">
                                    <select
                                        className="modern-select"
                                        value={vehicle}
                                        onChange={(e) => setVehicle(e.target.value)}
                                    >
                                        <option value="null">Select Vehicle</option>
                                        {vehicleList?.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((i, index) => (
                                            <option key={index} value={i.id}>{i.name}-{i.vehicle_num}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        } */}

                        {hasActiveFilters && (
                            <button className="clear-filters-btn" onClick={clearAllFilters}>
                                <X size={13} />
                                Clear
                            </button>
                        )}
                    </div>
                </div>
            )}

            <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
                <div className="stats-minimal-row">
                    <div className="stat-minimal-item">
                        <IndianRupee size={14} />
                        <span>Stage {level} — Showing</span>
                        <strong>{VehicleBillingList.length} vehicle bills</strong>
                    </div>
                </div>

                <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
                    <button className="toggle-filters-btn" onClick={() => setShowFilters(!showFilters)}>
                        <Filter size={14} />
                        <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                        {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                    </button>
                </div>
            </div>

            <div className="table-wrapper-minimal table-box scroll-container-table">
                {buffer ? (
                    <div className="loader-minimal"><div className="spinner-minimal"></div></div>
                ) : (
                    <table className="progress-table-minimal">
                        <thead className="table-heading stciky-heading-top">
                            <tr>
                                <th className="col-sno" style={{ width: '5%' }}>#</th>
                                <th className="col-period" style={{ width: '26%' }}>Vehicle / Project</th>
                                <th className="col-submitted text-center" style={{ width: '18%' }}>Total (KM / Amount)</th>
                                <th className="col-status text-center" style={{ width: '15%' }}>Status</th>
                                <th className="col-action text-center" style={{ width: '20%' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {VehicleBillingList?.map((i, index) => {
                                const isExpanded = expandedRow === index;
                                const details = i?.vehicle_billing_details;
                                const vehicleDetails = details?.vehicle_details;

                                const fixedKm = Number(vehicleDetails?.fixed_km || 0);
                                const fixedAmt = Number(vehicleDetails?.fixed_bill_amt || 0);
                                const extraKm = Number(details?.extra_km || 0);
                                const extraAmtPerKm = Number(vehicleDetails?.extra_amt_above_fix_km || 0);
                                const extraCharges = details?.extra_charges;

                                const totalKm = fixedKm + extraKm;
                                const totalAmt = fixedAmt + extraAmtPerKm * extraKm;

                                const nextApproval = details?.dynamic_approval?.find(
                                    (approval) => approval.level === i.level + 1
                                );
                                const shouldShowButtons =
                                    !nextApproval ||
                                    nextApproval.approval_status !== 'approved';

                                return (
                                    <React.Fragment key={index}>
                                        <tr className="progress-row">
                                            <td className="col-sno text-start">{index + 1}.</td>
                                            <td className="col-period">
                                                <button className="period-trigger" style={{ width: "100%" }} onClick={() => toggleRow(index)}>
                                                    <IndianRupee size={12} />
                                                    <span>{vehicleDetails?.name} • {vehicleDetails?.vehicle_num}</span>
                                                    {isExpanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                                                </button>
                                                <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '4px', paddingLeft: '4px' }}>
                                                    {vehicleDetails?.project_short_name || "N/A"} • {details?.month}/{details?.year}
                                                </div>
                                            </td>
                                            <td className="col-submitted text-center">
                                                <span className="badge-value" title={`Fixed: ${fixedKm} km / ₹${formatCurrencyIndian(fixedAmt)} | Extra: ${extraKm} km / ${extraCharges}`}>
                                                    {totalKm} km / ₹{formatCurrencyIndian(totalAmt)}
                                                </span>
                                            </td>
                                            <td className="col-status text-center">
                                                <ViewDynamicApprovalStatus dynamic_approval={vehicle.dynamic_approval} Table="Vehicle" />

                                            </td>
                                            <td className="col-action text-center">
                                                <div className="action-group-minimal" style={{ justifyContent: 'center' }}>
                                                    {shouldShowButtons ? (
                                                        <>
                                                            {(i.approval_status === 'pending' || i.approval_status === 'rejected') && (
                                                                <>
                                                                    {i.permissions === 'Finalize' ? (
                                                                        <DynamicVehicleFinal
                                                                            i={i}
                                                                            getVehicleBillingData={getVehicleBillingData}
                                                                            documentlist={i?.vehicle_details?.documents}
                                                                        />
                                                                    ) : (
                                                                        <DynamicRequestVehicleApproval i={i} getDynamicRequestData={getVehicleBillingData} />
                                                                    )}
                                                                    {i.permissions === 'Approve-Reject-Edit' && (
                                                                        <DynamicRequestVehicleEditApproval i={i} getDynamicRequestData={getVehicleBillingData} documentlist={details?.vehicle_details?.documentlist} />
                                                                    )}
                                                                </>
                                                            )}
                                                            {(i.approval_status === 'pending' || i.approval_status === 'approved') && (
                                                                <DynamicRequestVehicleRejection i={i} getDynamicRequestData={getVehicleBillingData} />
                                                            )}
                                                        </>
                                                    ) : (
                                                        <span style={{ fontSize: '11px', color: '#94a3b8' }}>Next Stage Action Performed</span>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>

                                        {isExpanded && (
                                            <tr className="expanded-row">
                                                <td colSpan={5}>
                                                    <div className="expanded-content-attractive">
                                                        <div className="expanded-content-header">
                                                            <div className="expanded-content-title">
                                                                <Sparkles size={13} />
                                                                <span>Full Vehicle Billing Details</span>
                                                            </div>
                                                        </div>

                                                        <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap', marginBottom: '14px' }}>
                                                            <div className="stage-card submitted" style={{ flex: 1, minWidth: '240px' }}>
                                                                <div className="stage-header">
                                                                    <IndianRupee size={14} />
                                                                    <span>Fixed Details</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">KM</span>
                                                                        <span className="amount">{fixedKm}</span>
                                                                    </div>
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Amount</span>
                                                                        <span className="amount">₹{formatCurrencyIndian(fixedAmt)}</span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="stage-card recommended" style={{ flex: 1, minWidth: '240px' }}>
                                                                <div className="stage-header">
                                                                    <IndianRupee size={14} />
                                                                    <span>Extra Details</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Extra KM</span>
                                                                        <span className="amount">{extraKm}</span>
                                                                    </div>
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Extra Amt/Km</span>
                                                                        <span className="amount">₹{formatCurrencyIndian(extraAmtPerKm)}</span>
                                                                    </div>
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Extra Charges</span>
                                                                        <span className="amount">₹{extraCharges}</span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="stage-card" style={{ flex: 1, minWidth: '240px', background: 'white' }}>
                                                                <div className="stage-header">
                                                                    <IndianRupee size={14} />
                                                                    <span>Total Details</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Total KM</span>
                                                                        <span className="amount">{totalKm}</span>
                                                                    </div>
                                                                    <div className="stage-row" style={{ fontWeight: 700 }}>
                                                                        <span className="stage-label">Total Amount</span>
                                                                        <span className="amount">₹{formatCurrencyIndian(totalAmt)}</span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="stage-card" style={{ flex: 1, minWidth: '240px', background: 'white' }}>
                                                                <div className="stage-header">
                                                                    <FileText size={14} />
                                                                    <span>Remarks</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    <ViewDynamicApprovalRemarks dynamic_approval={details?.dynamic_approval} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                            {(!VehicleBillingList || VehicleBillingList.length === 0) && (
                                <tr>
                                    <td colSpan={5}>
                                        <div className="empty-state-attractive">
                                            <div className="empty-state-icon-wrap"><IndianRupee size={32} /></div>
                                            <h4 className="empty-state-title">No Vehicle Requests Found</h4>
                                            <p className="empty-state-subtitle">No vehicle billing requests are pending at this stage.</p>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

// const DynamicBOQApprovalTable = ({ showdashboard, level, approval_stages }) => {
//     const empID = sessionStorage.getItem('sitemanagement_emp_id');
//     const siteRole = sessionStorage.getItem("sitemanagement_role");
//     const [projects, setProjects] = useState("");
//     const [projectsList, setProjectsList] = useState([]);
//     const [sorting, setSorting] = useState("asc_pr");

//     const [buffer, setBuffering] = useState(true); //buffering logic
//     const [buffer1, setBuffering1] = useState(true); //buffering logic
//     const [ImprestList, setImprestList] = useState([]);
//     const [previousStatus, setPreviousStatus] = useState("approved");
//     const [selectedStatus, setSelectedStatus] = useState("pending");
//     const [selectedProject, setProject] = useState("null");
//     const [fromdate, setFromDate] = useState("null");
//     const [todate, setToDate] = useState("null");
//     const [selectedDivision, setDivision] = useState(
//         `${sessionStorage.getItem("sitemanagement_project_sub_company") || null}`
//     );
//     const [SubCompany, setSubCompany] = useState([]);
//     const [expandedRow, setExpandedRow] = useState(null);
//     const [showFilters, setShowFilters] = useState(true);
//     const [filteredData, setFilteredData] = useState([]);
//     const [selectedName, setName] = useState("");


//     const toggleRow = (index) => setExpandedRow(expandedRow === index ? null : index);

//     const defaultDivision = `${sessionStorage.getItem("sitemanagement_project_sub_company") || null}`;

//     const hasActiveFilters =
//         selectedStatus !== "pending" ||
//         selectedProject !== "null" ||
//         selectedDivision !== defaultDivision ||
//         fromdate !== "null" ||
//         todate !== "null";

//     const clearAllFilters = () => {
//         setSelectedStatus("pending");
//         setPreviousStatus("approved");
//         setProject("null");
//         setDivision(defaultDivision);
//         setFromDate("null");
//         setToDate("null");
//     };

//     const getSubCompany = async () => {
//         setBuffering1(true); //buffering logic // Start Buffering
//         try {
//             const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
//             setSubCompany(res.data);
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setBuffering1(false); //buffering logic // End Buffering
//         }
//     };

//     useEffect(() => {
//         getSubCompany();
//     }, [])
//     const currentUrl = window.location.href;
//     const urlParts = currentUrl.split("/");
//     const navigate = useNavigate();
//     const ViewBOQ = (project, sub_company) => {
//         navigate(`/${urlParts[3]}/Invoiceformate/${project}/${sub_company}/`
//         );
//     };

//     //! ******************************API start***************************//
//     const getProjects = async (filters = {}) => {
//         setBuffering(true); //buffering logic // Start BufferingDD
//         try {
//             const params = new URLSearchParams();
//             if (filters.id) params.append('id', filters.id);
//             if (filters.sub_company) params.append('sub_company', filters.sub_company);
//             if (filters.current_level) params.append('current_level', filters.current_level);
//             if (filters.com_operator) params.append('com_operator', filters.com_operator);
//             if (filters.current_status) params.append('current_status', filters.current_status);
//             if (filters.previous_approval_status)
//                 params.append('previous_approval_status', filters.previous_approval_status);
//             const query = params.toString();
//             const queryString = query ? `?${query}` : '';

//             let url = `${BASE_URL}/siteproject/project_sub_company_BOQ_filter/${queryString}`;

//             const ress = await axios.get(url);

//             // Check: kya is project ka current `level` se pehle wale saare stages approved hain?
//             const isLevelReady = (project, level) => {
//                 // level 1 ke liye koi previous dependency nahi
//                 if (level <= 1) return true;

//                 const dynamicApprovals = project.dynamic_approvals || [];

//                 // 1 se (level - 1) tak har level ka approval check karo
//                 for (let lvl = 1; lvl < level; lvl++) {
//                     const approvalForLvl = dynamicApprovals.find(a => a.level === lvl);

//                     // agar us level ka approval hi nahi hai, ya approved nahi hai -> not ready
//                     if (!approvalForLvl || approvalForLvl.approval_status !== "approved") {
//                         return false;
//                     }
//                 }
//                 return true;
//             };

//             const filterProjectsByLevelReadiness = (projectsData, level) => {
//                 return projectsData.filter(project => isLevelReady(project, level));
//             };

//             const readyData = filterProjectsByLevelReadiness(ress.data, level);

//             if (siteRole === "SiteManagement") {
//                 setProjects(readyData);
//             } else {
//                 const sortedList = sortProjects(readyData, "site_prcode");
//                 setProjectsList(sortedList);
//             }
//         } catch (err) {
//             //toast Logic
//             handleErrorToast(err);
//         } finally {
//             setBuffering(false); // End Buffering
//         }
//     };
//     const fetchProjectsWithCurrentFilters = () => {
//         if (siteRole === "DataEntryOperator" && level !== 0) {
//             getProjects({ com_operator: empID, current_level: level, current_status: selectedStatus, previous_approval_status: previousStatus });
//         } else if (siteRole === "AuthorityEngineer" && level !== 0) {
//             getProjects({ authority_engineer: empID, current_level: level, current_status: selectedStatus, previous_approval_status: previousStatus });
//         } else if (level !== 0) {
//             getProjects({ sub_company: selectedDivision, });
//         }
//     };

//     useEffect(() => {
//         fetchProjectsWithCurrentFilters();
//     }, [selectedDivision, sorting, empID, level, selectedStatus, previousStatus]);
//     useEffect(() => {
//         applyFilters();
//     }, [projectsList, selectedName, sorting]);

//     const applyFilters = () => {
//         let tempFilteredData = projectsList;

//         if (selectedName) {
//             const lowercaseSelectedName = selectedName.toLowerCase();
//             tempFilteredData = tempFilteredData.filter((employee) => {
//                 const nameMatch = employee.site_prcode.toString().toLowerCase().includes(lowercaseSelectedName);
//                 const empCodeMatch = employee.project_short_name.toLowerCase().includes(lowercaseSelectedName);
//                 return nameMatch || empCodeMatch;
//             });
//         }

//         switch (sorting) {
//             case "asc_pr":
//                 tempFilteredData = sortProjects(tempFilteredData, "site_prcode");
//                 break;
//             case "desc_pr":
//                 tempFilteredData = sortProjects(tempFilteredData, "site_prcode").reverse();
//                 break;
//             case "asc_short_name":
//                 tempFilteredData = tempFilteredData.sort((a, b) =>
//                     a.project_short_name.localeCompare(b.project_short_name)
//                 );
//                 break;
//             case "desc_short_name":
//                 tempFilteredData = tempFilteredData.sort((a, b) =>
//                     b.project_short_name.localeCompare(a.project_short_name)
//                 );
//                 break;
//             default:
//                 break;
//         }

//         setFilteredData(tempFilteredData);
//     };


//     const mergeDynamicStagesWithApprovals = (dynamicStages = [], dynamicApprovals = []) => {
//         return dynamicStages.map((stage) => {
//             const approvalForLevel = dynamicApprovals.find(
//                 (approval) => approval.level === stage.level
//             );

//             // agar is level ka approval data maujood hai, wahi use karo (stage ko replace)
//             // warna original stage data hi rakho
//             return approvalForLevel ? { ...approvalForLevel, isApproval: true } : { ...stage, isApproval: false };
//         });
//     };

//     return (
//         <div className="progress-modern-container">
//             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

//             {siteRole !== "SiteManagement" && showFilters && (
//                 <div className="filter-bar-attractive">
//                     <div className="filter-group-attractive">


//                         <div className={`filter-chip ${sorting !== "asc_pr" ? "active" : ""}`}>
//                             <div><Sort /></div>
//                             <div className="filter-chip-content">
//                                 <select
//                                     className="modern-select"
//                                     value={sorting}
//                                     onChange={(e) => setSorting(e.target.value)}
//                                     style={{ cursor: 'pointer' }}
//                                 >
//                                     <option value="asc_pr">Asc. Pr Code</option>
//                                     <option value="desc_pr">Desc. Pr Code</option>
//                                     <option value="asc_short_name">Asc. Project Name</option>
//                                     <option value="desc_short_name">Desc. Project Name</option>
//                                 </select>
//                             </div>
//                         </div>

//                         <div className={`filter-chip ${selectedName !== "" ? "active" : ""}`} style={{ minWidth: '240px' }}>
//                             <div><Search size={15} /></div>
//                             <div className="filter-chip-content" style={{ width: '100%' }}>
//                                 <input
//                                     className="modern-select"
//                                     style={{ width: '100%' }}
//                                     placeholder="Code / Project Name"
//                                     value={selectedName}
//                                     onChange={(e) => setName(e.target.value)}
//                                 />
//                             </div>
//                         </div>

//                         {hasActiveFilters && (
//                             <button className="clear-filters-btn" onClick={clearAllFilters}>
//                                 <X size={13} />
//                                 Clear
//                             </button>
//                         )}
//                     </div>
//                 </div>
//             )}

//             <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
//                 <div className="stats-minimal-row">
//                     <div className="stat-minimal-item">
//                         <IndianRupee size={14} />
//                         <span>Stage {level} — Showing</span>
//                         <strong>{filteredData.length} BOQ Data</strong>
//                     </div>
//                 </div>

//                 <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
//                     <button className="toggle-filters-btn" onClick={() => setShowFilters(!showFilters)}>
//                         <Filter size={14} />
//                         <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
//                         {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
//                     </button>
//                 </div>
//             </div>

//             <div className="table-wrapper-minimal table-box scroll-container-table">
//                 {buffer ? (
//                     <div className="loader-minimal"><div className="spinner-minimal"></div></div>
//                 ) : (
//                     <table className="progress-table-minimal">
//                         <thead className="table-heading" style={{ zIndex: 999 }}>
//                             <tr >
//                                 <th className="col-sno" style={{ width: '6%' }}>#</th>
//                                 <th className="col-period text-left">Project Code</th>
//                                 <th className="col-period text-center">Project Name</th>
//                                 <th className="col-status text-center">View BOQ</th>
//                                 <th className="col-status text-center">Approval Status</th>

//                                 {siteRole !== "BD" && <th className="col-action text-center">View Invoice</th>}
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {filteredData?.map((i, index) => {
//                                 const isExpanded = expandedRow === index;
//                                 const details = i?.tender_amount_details;

//                                 const nextApproval = details?.dynamic_approval?.find(
//                                     (approval) => approval.level === i.level + 1
//                                 );
//                                 const shouldShowButtons =
//                                     !nextApproval ||
//                                     nextApproval.approval_status !== 'approved';

//                                 return (
//                                     <React.Fragment key={index}>
//                                         <tr className="progress-row" title={`Status : ${i.approval_status}`}>
//                                             <td className="col-sno text-start">{index + 1}</td>
//                                             <td className="col-period text-left">{i?.site_prcode}</td>
//                                             <td className="col-period text-center">{i.project_short_name}</td>
//                                             <td className="col-status text-center">
//                                                 <button
//                                                     className="action-icon"
//                                                     style={{ backgroundColor: "#00000075" }}
//                                                     onClick={() => ViewBOQ(i.id, i.sub_company)}
//                                                     title="View BOQ Details"
//                                                 >
//                                                     <FileText size={16} color="white" />
//                                                 </button>
//                                             </td>
//                                             <td className="col-status text-center">
//                                                 <ViewDynamicboqStatus dynamic_approval={mergeDynamicStagesWithApprovals(i.dynamic_stages, i.dynamic_approvals)} Table="Project" />
//                                             </td>
//                                             <td className="col-action text-center">
//                                                 <div className="action-group-minimal" style={{ justifyContent: 'center' }}>
//                                                     {shouldShowButtons ? (
//                                                         <>
//                                                             {(i.approval_status === 'pending' || i.approval_status === 'rejected' || level !== 0) && (
//                                                                 <>
//                                                                     {i.permissions === 'Finalize' ? (
//                                                                         <DynamicRequestTenderApproval i={i} getDynamicRequestData={fetchProjectsWithCurrentFilters} dynamicApprovals={i.dynamic_approvals} dynamicStages={i.dynamic_stages} level={level} />
//                                                                     ) : (
//                                                                         <DynamicRequestTenderApproval i={i} getDynamicRequestData={fetchProjectsWithCurrentFilters} dynamicApprovals={i.dynamic_approvals} dynamicStages={i.dynamic_stages} level={level} />
//                                                                     )}
//                                                                     {i.permissions === 'Approve-Reject-Edit' && (
//                                                                         <DynamicRequestTenderEditApproval i={i} getDynamicRequestData={fetchProjectsWithCurrentFilters} />
//                                                                     )}
//                                                                 </>
//                                                             )}
//                                                             {(i.approval_status === 'pending' || i.approval_status === 'approved' || level !== 0) && (
//                                                                 <DynamicRequestTenderRejection i={i} getDynamicRequestData={fetchProjectsWithCurrentFilters} dynamicApprovals={i.dynamic_approvals} dynamicStages={i.dynamic_stages} level={level} />
//                                                             )}
//                                                         </>
//                                                     ) : (
//                                                         <span style={{ fontSize: '11px', color: '#94a3b8' }}>Next Stage Action Performed</span>
//                                                     )}
//                                                 </div>
//                                             </td>
//                                         </tr>

//                                         {isExpanded && (
//                                             <tr className="expanded-row">
//                                                 <td colSpan={5}>
//                                                     <div className="expanded-content-attractive">
//                                                         <div className="expanded-content-header">
//                                                             <div className="expanded-content-title">
//                                                                 <Sparkles size={13} />
//                                                                 <span>Full Tender / BOQ Details</span>
//                                                             </div>
//                                                         </div>

//                                                         <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap', marginBottom: '14px' }}>
//                                                             <div className="stage-card submitted" style={{ flex: 1, minWidth: '240px' }}>
//                                                                 <div className="stage-header">
//                                                                     <IndianRupee size={14} />
//                                                                     <span>Amount Details</span>
//                                                                 </div>
//                                                                 <div className="stage-content">
//                                                                     <div className="stage-row">
//                                                                         <span className="stage-label">Amount</span>
//                                                                         <span className="amount">₹{formatCurrencyIndian(details?.amount)}</span>
//                                                                     </div>
//                                                                     <div className="stage-row">
//                                                                         <span className="stage-label">Approved Amount</span>
//                                                                         <span className="amount">₹{formatCurrencyIndian(details?.approved_amount)}</span>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>

//                                                             <div className="stage-card recommended" style={{ flex: 1, minWidth: '240px' }}>
//                                                                 <div className="stage-header">
//                                                                     <FileText size={14} />
//                                                                     <span>Dates</span>
//                                                                 </div>
//                                                                 <div className="stage-content">
//                                                                     <div className="stage-row">
//                                                                         <span className="stage-label">Date</span>
//                                                                         <span className="amount">{formatDate(details?.date)}</span>
//                                                                     </div>
//                                                                     <div className="stage-row">
//                                                                         <span className="stage-label">Expiry Date</span>
//                                                                         <span className="amount">{formatDate(details?.expiry_date)}</span>
//                                                                     </div>
//                                                                     <div className="stage-row">
//                                                                         <span className="stage-label">Release Date</span>
//                                                                         <span className="amount">{formatDate(details?.release_date)}</span>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>

//                                                             <div className="stage-card" style={{ flex: 1, minWidth: '240px', background: 'white' }}>
//                                                                 <div className="stage-header">
//                                                                     <FileText size={14} />
//                                                                     <span>Document</span>
//                                                                 </div>
//                                                                 <div className="stage-content">
//                                                                     {details?.document ? (
//                                                                         <a href={details.document} target="_blank" rel="noreferrer">
//                                                                             <div className="flex-row justify-center">
//                                                                                 <DocumentIcon />
//                                                                             </div>
//                                                                         </a>
//                                                                     ) : (
//                                                                         <span className="stage-label">No Document Attached</span>
//                                                                     )}
//                                                                 </div>
//                                                             </div>

//                                                             <div className="stage-card" style={{ flex: 1, minWidth: '240px', background: 'white' }}>
//                                                                 <div className="stage-header">
//                                                                     <FileText size={14} />
//                                                                     <span>Remarks</span>
//                                                                 </div>
//                                                                 <div className="stage-content">
//                                                                     <ViewDynamicApprovalRemarks dynamic_approval={details?.dynamic_approval} />
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </td>
//                                             </tr>
//                                         )}
//                                     </React.Fragment>
//                                 );
//                             })}

//                         </tbody>
//                     </table>
//                 )}
//             </div>
//         </div>
//     );
// };

const DynamicBOQApprovalTable = ({ showdashboard, level, approval_stages }) => {
    const empID = sessionStorage.getItem('sitemanagement_emp_id');
    const siteRole = sessionStorage.getItem("sitemanagement_role");
    const [projects, setProjects] = useState("");
    const [projectsList, setProjectsList] = useState([]);
    const [sorting, setSorting] = useState("asc_pr");

    const [buffer, setBuffering] = useState(true); //buffering logic
    const [buffer1, setBuffering1] = useState(true); //buffering logic
    const [ImprestList, setImprestList] = useState([]);
    const [previousStatus, setPreviousStatus] = useState("approved");
    const [selectedStatus, setSelectedStatus] = useState("pending");
    const [selectedProject, setProject] = useState("null");
    const [fromdate, setFromDate] = useState("null");
    const [todate, setToDate] = useState("null");
    const [selectedDivision, setDivision] = useState(
        `${sessionStorage.getItem("sitemanagement_project_sub_company") || null}`
    );
    const [SubCompany, setSubCompany] = useState([]);
    const [expandedRow, setExpandedRow] = useState(null);
    const [showFilters, setShowFilters] = useState(true);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedName, setName] = useState("");


    const toggleRow = (index) => setExpandedRow(expandedRow === index ? null : index);

    const defaultDivision = `${sessionStorage.getItem("sitemanagement_project_sub_company") || null}`;

    const hasActiveFilters =
        selectedStatus !== "pending" ||
        selectedProject !== "null" ||
        selectedDivision !== defaultDivision ||
        fromdate !== "null" ||
        todate !== "null";

    const clearAllFilters = () => {
        setSelectedStatus("pending");
        setPreviousStatus("approved");
        setProject("null");
        setDivision(defaultDivision);
        setFromDate("null");
        setToDate("null");
    };

    const getSubCompany = async () => {
        setBuffering1(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompany(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering1(false); //buffering logic // End Buffering
        }
    };

    useEffect(() => {
        getSubCompany();
    }, [])
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split("/");
    const navigate = useNavigate();
    const ViewBOQ = (project, sub_company) => {
        navigate(`/${urlParts[3]}/Invoiceformate/${project}/${sub_company}/`
        );
    };

    //! ******************************API start***************************//
    const getProjects = async (filters = {}) => {
        setBuffering(true); //buffering logic // Start BufferingDD
        try {
            const params = new URLSearchParams();
            if (filters.id) params.append('id', filters.id);
            if (filters.sub_company) params.append('sub_company', filters.sub_company);
            if (filters.current_level) params.append('current_level', filters.current_level);
            if (filters.com_operator) params.append('com_operator', filters.com_operator);
            if (filters.current_status) params.append('current_status', filters.current_status);
            if (filters.previous_approval_status)
                params.append('previous_approval_status', filters.previous_approval_status);
            const query = params.toString();
            const queryString = query ? `?${query}` : '';

            let url = `${BASE_URL}/siteproject/project_sub_company_BOQ_filter/${queryString}`;

            const ress = await axios.get(url);

            // Check: kya is project ka current `level` se pehle wale saare stages approved hain?
            const isLevelReady = (project, level) => {
                // level 1 ke liye koi previous dependency nahi
                if (level <= 1) return true;

                const dynamicApprovals = project.dynamic_approvals || [];

                // 1 se (level - 1) tak har level ka approval check karo
                for (let lvl = 1; lvl < level; lvl++) {
                    const approvalForLvl = dynamicApprovals.find(a => a.level === lvl);

                    // agar us level ka approval hi nahi hai, ya approved nahi hai -> not ready
                    if (!approvalForLvl || approvalForLvl.approval_status !== "approved") {
                        return false;
                    }
                }
                return true;
            };

            const filterProjectsByLevelReadiness = (projectsData, level) => {
                return projectsData.filter(project => isLevelReady(project, level));
            };

            const readyData = filterProjectsByLevelReadiness(ress.data, level);

            if (siteRole === "SiteManagement") {
                setProjects(readyData);
            } else {
                const sortedList = sortProjects(readyData, "site_prcode");
                setProjectsList(sortedList);
            }
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };
    const fetchProjectsWithCurrentFilters = () => {
        if (siteRole === "DataEntryOperator" && level !== 0) {
            getProjects({ com_operator: empID, current_level: level, current_status: selectedStatus, previous_approval_status: previousStatus });
        } else if (siteRole === "AuthorityEngineer" && level !== 0) {
            getProjects({ authority_engineer: empID, current_level: level, current_status: selectedStatus, previous_approval_status: previousStatus });
        } else if (level !== 0) {
            getProjects({ sub_company: selectedDivision, });
        }
    };

    useEffect(() => {
        fetchProjectsWithCurrentFilters();
    }, [selectedDivision, sorting, empID, level, selectedStatus, previousStatus]);
    useEffect(() => {
        applyFilters();
    }, [projectsList, selectedName, sorting]);

    const applyFilters = () => {
        let tempFilteredData = projectsList;

        if (selectedName) {
            const lowercaseSelectedName = selectedName.toLowerCase();
            tempFilteredData = tempFilteredData.filter((employee) => {
                const nameMatch = employee.site_prcode.toString().toLowerCase().includes(lowercaseSelectedName);
                const empCodeMatch = employee.project_short_name.toLowerCase().includes(lowercaseSelectedName);
                return nameMatch || empCodeMatch;
            });
        }

        switch (sorting) {
            case "asc_pr":
                tempFilteredData = sortProjects(tempFilteredData, "site_prcode");
                break;
            case "desc_pr":
                tempFilteredData = sortProjects(tempFilteredData, "site_prcode").reverse();
                break;
            case "asc_short_name":
                tempFilteredData = tempFilteredData.sort((a, b) =>
                    a.project_short_name.localeCompare(b.project_short_name)
                );
                break;
            case "desc_short_name":
                tempFilteredData = tempFilteredData.sort((a, b) =>
                    b.project_short_name.localeCompare(a.project_short_name)
                );
                break;
            default:
                break;
        }

        setFilteredData(tempFilteredData);
    };


    const mergeDynamicStagesWithApprovals = (dynamicStages = [], dynamicApprovals = []) => {
        return dynamicStages.map((stage) => {
            const approvalForLevel = dynamicApprovals.find(
                (approval) => approval.level === stage.level
            );

            // agar is level ka approval data maujood hai, wahi use karo (stage ko replace)
            // warna original stage data hi rakho
            return approvalForLevel ? { ...approvalForLevel, isApproval: true } : { ...stage, isApproval: false };
        });
    };

    const getSubCompanyName = (id) => {
        const found = SubCompany?.find((s) => s.id === id);
        return found?.name || found?.sub_company_name || "N/A";
    };

    return (
        <div className="progress-modern-container">
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

            {siteRole !== "SiteManagement" && showFilters && (
                <div className="filter-bar-attractive">
                    <div className="filter-group-attractive">


                        <div className={`filter-chip ${sorting !== "asc_pr" ? "active" : ""}`}>
                            <div><Sort /></div>
                            <div className="filter-chip-content">
                                <select
                                    className="modern-select"
                                    value={sorting}
                                    onChange={(e) => setSorting(e.target.value)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <option value="asc_pr">Asc. Pr Code</option>
                                    <option value="desc_pr">Desc. Pr Code</option>
                                    <option value="asc_short_name">Asc. Project Name</option>
                                    <option value="desc_short_name">Desc. Project Name</option>
                                </select>
                            </div>
                        </div>

                        <div className={`filter-chip ${selectedName !== "" ? "active" : ""}`} style={{ minWidth: '240px' }}>
                            <div><Search size={15} /></div>
                            <div className="filter-chip-content" style={{ width: '100%' }}>
                                <input
                                    className="modern-select"
                                    style={{ width: '100%' }}
                                    placeholder="Code / Project Name"
                                    value={selectedName}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>
                        </div>

                        {hasActiveFilters && (
                            <button className="clear-filters-btn" onClick={clearAllFilters}>
                                <X size={13} />
                                Clear
                            </button>
                        )}
                    </div>
                </div>
            )}

            <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
                <div className="stats-minimal-row">
                    <div className="stat-minimal-item">
                        <IndianRupee size={14} />
                        <span>Stage {level} — Showing</span>
                        <strong>{filteredData.length} BOQ Data</strong>
                    </div>
                </div>

                <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
                    <button className="toggle-filters-btn" onClick={() => setShowFilters(!showFilters)}>
                        <Filter size={14} />
                        <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                        {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                    </button>
                </div>
            </div>

            <div className="table-wrapper-minimal table-box scroll-container-table">
                {buffer ? (
                    <div className="loader-minimal"><div className="spinner-minimal"></div></div>
                ) : (
                    <table className="progress-table-minimal">
                        <thead className="table-heading" style={{ zIndex: 999 }}>
                            <tr >
                                <th className="col-sno" style={{ width: '6%' }}>#</th>
                                <th className="col-period text-left">Project Code</th>
                                <th className="col-period text-center">Project Name</th>
                                <th className="col-status text-center">View BOQ</th>
                                <th className="col-status text-center">Approval Status</th>

                                {siteRole !== "BD" && <th className="col-action text-center">Action</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData?.map((i, index) => {
                                const isExpanded = expandedRow === index;
                                const details = i?.tender_amount_details;

                                const nextApproval = details?.dynamic_approval?.find(
                                    (approval) => approval.level === i.level + 1
                                );
                                const shouldShowButtons =
                                    !nextApproval ||
                                    nextApproval.approval_status !== 'approved';

                                const mergedStages = mergeDynamicStagesWithApprovals(i.dynamic_stages, i.dynamic_approvals);

                                return (
                                    <React.Fragment key={index}>
                                        <tr className="progress-row" title={`Status : ${i.approval_status}`}>
                                            <td className="col-sno text-start">{index + 1}</td>
                                            <td className="col-period text-left">{i?.site_prcode}</td>
                                            <td className="col-period text-center">
                                                <button className="period-trigger" style={{ width: "100%" }} onClick={() => toggleRow(index)}>
                                                    <IndianRupee size={12} />
                                                    <span>{i.project_short_name}</span>
                                                    {isExpanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                                                </button>
                                                <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '4px', paddingLeft: '4px' }}>
                                                    {i.authority_engineer_name || "N/A"}
                                                </div>
                                            </td>
                                            <td className="col-status text-center">
                                                <button
                                                    className="action-icon"
                                                    style={{ backgroundColor: "#00000075" }}
                                                    onClick={() => ViewBOQ(i.id, i.sub_company)}
                                                    title="View BOQ Details"
                                                >
                                                    <FileText size={16} color="white" />
                                                </button>
                                            </td>
                                            <td className="col-status text-center">
                                                <ViewDynamicboqStatus dynamic_approval={mergedStages} Table="Project" />
                                            </td>
                                            <td className="col-action text-center">
                                                <div className="action-group-minimal" style={{ justifyContent: 'center' }}>
                                                    {shouldShowButtons ? (
                                                        <>
                                                            {(i.approval_status === 'pending' || i.approval_status === 'rejected' || level !== 0) && (
                                                                <>
                                                                    {i.permissions === 'Finalize' ? (
                                                                        <DynamicRequestTenderApproval i={i} getDynamicRequestData={fetchProjectsWithCurrentFilters} dynamicApprovals={i.dynamic_approvals} dynamicStages={i.dynamic_stages} level={level} />
                                                                    ) : (
                                                                        <DynamicRequestTenderApproval i={i} getDynamicRequestData={fetchProjectsWithCurrentFilters} dynamicApprovals={i.dynamic_approvals} dynamicStages={i.dynamic_stages} level={level} />
                                                                    )}
                                                                    {i.permissions === 'Approve-Reject-Edit' && (
                                                                        <DynamicRequestTenderEditApproval i={i} getDynamicRequestData={fetchProjectsWithCurrentFilters} />
                                                                    )}
                                                                </>
                                                            )}
                                                            {(i.approval_status === 'pending' || i.approval_status === 'approved' || level !== 0) && (
                                                                <DynamicRequestTenderRejection i={i} getDynamicRequestData={fetchProjectsWithCurrentFilters} dynamicApprovals={i.dynamic_approvals} dynamicStages={i.dynamic_stages} level={level} />
                                                            )}
                                                        </>
                                                    ) : (
                                                        <span style={{ fontSize: '11px', color: '#94a3b8' }}>Next Stage Action Performed</span>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>

                                        {isExpanded && (
                                            <tr className="expanded-row">
                                                <td colSpan={5}>
                                                    <div className="expanded-content-attractive">
                                                        <div className="expanded-content-header">
                                                            <div className="expanded-content-title">
                                                                <Sparkles size={13} />
                                                                <span>Full Project / BOQ Details</span>
                                                            </div>
                                                        </div>

                                                        <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap', marginBottom: '14px' }}>
                                                            <div className="stage-card submitted" style={{ flex: 1, minWidth: '240px' }}>
                                                                <div className="stage-header">
                                                                    <FileText size={14} />
                                                                    <span>Project Details</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Pr Code</span>
                                                                        <span className="amount">{i.site_prcode}</span>
                                                                    </div>
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Project Name</span>
                                                                        <span className="amount">{i.project_short_name}</span>
                                                                    </div>

                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Authority Engineer</span>
                                                                        <span className="amount">{i.authority_engineer_name || "N/A"}</span>
                                                                    </div>
                                                                </div>
                                                            </div>



                                                            <div className="stage-card" style={{ flex: 1, minWidth: '240px', background: 'white' }}>
                                                                <div className="stage-header">
                                                                    <IndianRupee size={14} />
                                                                    <span>Stages Overview</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    {mergedStages?.map((stage, sIdx) => (
                                                                        <div className="stage-row" key={sIdx}>
                                                                            <span className="stage-label">
                                                                                L{stage.level} • {stage.role_name || stage.role_details?.role_name || "N/A"}
                                                                            </span>
                                                                            <span className="amount">
                                                                                {stage.isApproval ? stage.approval_status : "not-reached"}
                                                                            </span>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>

                                                            <div className="stage-card" style={{ flex: 1, minWidth: '240px', background: 'white' }}>
                                                                <div className="stage-header">
                                                                    <FileText size={14} />
                                                                    <span>Remarks</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    <ViewDynamicApprovalRemarks dynamic_approval={i.dynamic_approvals} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                );
                            })}

                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

export {
    DynamicImprestApprovalTable,
    DynamicsExpenseApproveTable,
    DynamicOfficeBillingTable,
    DynamicVehicleApprovalTable,
    DynamicBOQApprovalTable,
}